export class ChatReplyModel {
  id: string;
  text: string;
  author: string;
  uuid: string;
  deleted: boolean;
}
